import { NotificationService } from './../../../common/services/notification/notification.service';
import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  UPDATE_SHIPMENT_REQUESTED,
  UPDATE_SHIPMENT_SUCCEEDED,
  DOWNLOAD_INVOICE_REQUESTED,
  DOWNLOAD_INVOICE_SUCCEEDED,
  REGENERATE_INVOICE_SUCCEEDED,
  REGENERATE_INVOICE_REQUESTED,
  RETURN_ORDER_PRODUCT_ITEM_REQUESTED,
  CANCEL_SHIPMENT_PRODUCT_REQUESTED,
  POPULATE_CONFIRM_SHIPMENT_REQUESTED,
  SEND_SHIPMENT_TO_ACCOUNTING_REQUESTED,
  SET_SHIPMENT_AS_PRINTED_REQUESTED,
  FETCH_SHIPMENT_DETAIL_SUCCESSED,
  FETCH_SHIPMENT_DETAIL_REQUESTED,
  CONFIRM_RETURN_ORDER_PRODUCT_ITEM_REQUESTED
} from './edit.actions';
import { ApiService } from '../../../api/api.service';
import store from '../../../store/store.module';
import { UtilityService } from '../../../common/services/utility/utility.service';

function* watchFetchShipmentDetailRequest() {
  yield takeEvery(FETCH_SHIPMENT_DETAIL_REQUESTED, function* (action: any) {
    const api = AppInjector.get(ApiService);
    try {
      let result = yield api.orderProduct.getItemById(action.data).toPromise();
      // const payment_refund_pendings = yield api.payment.getPaymentRefundByOrderId(result.order_id).toPromise();
      yield put({ type: FETCH_SHIPMENT_DETAIL_SUCCESSED, data: result });
    } catch (e) {
      yield put({ type: API_CALL_ERROR, error: e });
    }
  });
}

function* watchConfirmReturnOrderProductRequest() {
  yield takeEvery(CONFIRM_RETURN_ORDER_PRODUCT_ITEM_REQUESTED, function* (action: any) {
    const api = AppInjector.get(ApiService);
    try {
      // yield api.order
      //   .confirmReturnOrderProductsShipment(action.data.order_id, action.data.product_id, {
      //     delivery_status: action.data.status,
      //     delivery_type: action.data.type
      //   })
      //   .toPromise();
      AppInjector.get(NotificationService).show('success', 'Confirm return item successed', 3000);
      yield put({ type: FETCH_SHIPMENT_DETAIL_REQUESTED, data: action.data.shipment_inc_num });
    } catch (e) {
      yield put({ type: API_CALL_ERROR, error: e });
    }
  });
}

function* updateShipment(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.orderProduct.update(action.data).toPromise();
    yield put({ type: UPDATE_SHIPMENT_SUCCEEDED, data: result });
    yield put({ type: FETCH_SHIPMENT_DETAIL_REQUESTED, data: result.id });
    AppInjector.get(NotificationService).show('success', 'Shipment Updated', 3000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateShipmentRequest() {
  yield takeEvery(UPDATE_SHIPMENT_REQUESTED, updateShipment);
}

function* downloadInvoice(action) {
  const api = AppInjector.get(ApiService);
  try {
    // let result = yield api.orderProduct.downloadInvoice(action.data.shipment_id).toPromise();
    // yield put({ type: DOWNLOAD_INVOICE_SUCCEEDED, data: result.data.link, mediaPath: action.mediaPath, windowReference: action.windowReference, shipment_id: action.data.shipment_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDownloadInvoiceRequest() {
  yield takeEvery(DOWNLOAD_INVOICE_REQUESTED, downloadInvoice);
}

function* downloadInvoiceCompleted(action) {
  try {
    if (action.windowReference) {
      action.windowReference.location = `${action.mediaPath}/${action.data}`;
      action.windowReference.focus();
    } else {
      window.open(`${action.mediaPath}/${action.data}`, '_blank');
    }
    yield put({ type: SET_SHIPMENT_AS_PRINTED_REQUESTED, data: action.shipment_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDownloadInvoiceCompleted() {
  yield takeEvery(DOWNLOAD_INVOICE_SUCCEEDED, downloadInvoiceCompleted);
}

function* regenerateInvoiceCompleted(action) {
  try {
    const utilityService = AppInjector.get(UtilityService);
    let path = `${action.mediaPath}/${action.data}?${utilityService.generateRandom()}`;
    if (action.windowReference) {
      action.windowReference.location = `${path}`;
      action.windowReference.focus();
    } else {
      window.open(`${path}`, '_blank');
    }
    AppInjector.get(NotificationService).show('success', `Successfully regenerate invoice <a href="${path}" target="_blank">Click here to download</a>`, 10000, false, true);
    yield put({ type: SET_SHIPMENT_AS_PRINTED_REQUESTED, data: action.shipment_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRegenerateInvoiceCompleted() {
  yield takeEvery(REGENERATE_INVOICE_SUCCEEDED, regenerateInvoiceCompleted);
}

function* regenerateInvoice(action) {
  const api = AppInjector.get(ApiService);
  try {
    // let result = yield api.orderProduct.regenerateInvoice(action.data.shipment_id).toPromise();
    // yield put({ type: REGENERATE_INVOICE_SUCCEEDED, data: result.data.link, mediaPath: action.mediaPath, windowReference: action.windowReference, shipment_id: action.data.shipment_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRegenerateInvoiceRequest() {
  yield takeEvery(REGENERATE_INVOICE_REQUESTED, regenerateInvoice);
}

function* changeProductShipmentStatus(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.order
      .prepareOrderProductsShipment(action.data.order_id, action.data.product_id, {
        delivery_status: action.data.status,
        delivery_type: action.data.type
      })
      .toPromise();
    AppInjector.get(NotificationService).show('success', 'Return item successed', 3000);
    yield put({ type: FETCH_SHIPMENT_DETAIL_REQUESTED, data: action.data.shipment_inc_num });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* changeProductShipmentStatusRequest() {
  yield takeEvery(RETURN_ORDER_PRODUCT_ITEM_REQUESTED, changeProductShipmentStatus);
}

function* cancelProductShipmentStatus(action) {
  const api = AppInjector.get(ApiService);
  try {
    // yield api.orderProduct.cancelOrderProducts(action.data.order_package_id, action.data.product_id, action.data).toPromise();
    AppInjector.get(NotificationService).show('success', 'Cancel item successed', 3000);
    yield put({ type: FETCH_SHIPMENT_DETAIL_REQUESTED, data: action.data.shipment_inc_num });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* cancelProductShipmentStatusRequest() {
  yield takeEvery(CANCEL_SHIPMENT_PRODUCT_REQUESTED, cancelProductShipmentStatus);
}

function* populateShipment(action) {
  const api = AppInjector.get(ApiService);
  try {
    // yield api.orderProduct.populateShipment().toPromise();
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchPopulateShipmentRequest() {
  yield takeEvery(POPULATE_CONFIRM_SHIPMENT_REQUESTED, populateShipment);
}

function* sendToAccounting(action) {
  const api = AppInjector.get(ApiService);
  try {
    // yield api.orderProduct.sendToAccountingTool(action.data).toPromise();
    // AppInjector.get(NotificationService).show('success', 'Sent to accounting tools!', 3000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendToXeroRequest() {
  yield takeEvery(SEND_SHIPMENT_TO_ACCOUNTING_REQUESTED, sendToAccounting);
}

function* setShipmentAsPrinted(action) {
  const api = AppInjector.get(ApiService);
  try {
    // yield api.orderProduct.setShipmentAsPrinted(action.data).toPromise();
    // yield put({ type: SET_SHIPMENT_AS_PRINTED_SUCCEEDED, data: action.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSetShipmentAsPrintedRequest() {
  yield takeEvery(SET_SHIPMENT_AS_PRINTED_REQUESTED, setShipmentAsPrinted);
}

export default [
  watchUpdateShipmentRequest,
  watchConfirmReturnOrderProductRequest,
  watchFetchShipmentDetailRequest,
  watchDownloadInvoiceRequest,
  watchDownloadInvoiceCompleted,
  watchRegenerateInvoiceRequest,
  watchRegenerateInvoiceCompleted,
  changeProductShipmentStatusRequest,
  cancelProductShipmentStatusRequest,
  watchPopulateShipmentRequest,
  watchSendToXeroRequest,
  watchSetShipmentAsPrintedRequest
];
